import { FormattedShopifyProduct } from '@portal/types/shopify/product.formatted.types';
import { getShopifyCustomMetafield } from '../../shopify/getShopifyCustomMetafield';

/* ----- metafields ------- */

export const getUrlMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'url');
};

export const getOriginalPriceMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'original_price');
};

export const getLabelMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'label');
};

export const getShortDescriptionMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'short_description');
};

export const getChargeFrequencyMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'frequency_note');
};

export const getOriginalPriceFootnoteMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'original_price_footnote');
};

export const getIsMemberOnlyMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'members_only');
};

// TODO: update this util function to fetch the flavor group name (parent product)
export const getFlavorGroupNameMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'flavor_group');
};

export const getFlavorNameMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'flavor');
};

export const getFlavorColorMetafield = (product: FormattedShopifyProduct) => {
  return getShopifyCustomMetafield(product, 'flavor_hex_code');
};
